import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-confirmation-modal',
  template: `
    <div class="modal-header">
      <h4 class="modal-title">{{title}}</h4>
      <button type="button" class="close" aria-label="Close" (click)="dismiss()">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body text-center">
      <div class="py-3">
      {{message}}
      <div class="mt-3">
        <button type="button" class="btn mr-2 btn-primary" (click)="accept()">{{ btnOkText }}</button>
        <button type="button" class="btn btn-outline-dark" (click)="decline()">{{ btnCancelText }}</button>
      </div>
      </div>
    </div>
    
  `
}) 

export class ConfirmationModalComponent {
  @Input() title;
  @Input() message; 
  @Input() btnOkText: string;
  @Input() btnCancelText: string;  

  constructor(public activeModal: NgbActiveModal) { }

  accept(): void {  
    this.activeModal.close(true);
  }

  decline(): void { 
    this.activeModal.close(false);
  }

  dismiss(): void {  
    this.activeModal.dismiss();
  }
} 
